import { requestData } from "./request";

//埋点
export const buryingPoint = data => {
  return requestData("post", "/applet/AAUser/buryingPoint", data);
};

export const getZoneList = data => {
  return requestData("get", "/applet/ALogin/getTelephoneCodeList", data);
};

export const getFreezingModeList = data => {
  return requestData("get", "/applet/AAuction/getFreezingModeList", data);
};

// 获取当前热拍列表
export const getHotAuctionList = data => {
  return requestData("post", "/applet/AAuction/getHotAuctionList", data);
};
// 首页主题市场
export const getCategoryTree = data => {
  return requestData("get", "/common/CCategory/getCategoryTree", data);
};

// 首页行业资讯
// pageNo; //页码
// pageSize; //每页长度
// articleCategoryId; //咨询分类ID
export const articlePageList = data => {
  return requestData("get", "/applet/AArticle/articlePageList", data);
};
// 咨讯分类列表
export const articleCategoryList = data => {
  return requestData("get", "/applet/AArticle/articleCategoryList", data);
};
// 咨询详情
// id
export const articleDetailsById = data => {
  return requestData("get", "/applet/AArticle/articleDetailsById", data);
};
// 埋点接口
// id; //咨询ID
// type; //1-点赞，2-浏览
export const articleBuried = data => {
  return requestData("get", "/applet/AArticle/articleBuried", data);
};

// 账号密码注册
// {
//     type :  ,           //登录类型：1-账号密码登录，2-手机号,验证码登录
//     wxUser : {          //账户密码登录的时候传递
//         wxPhone : ,     //账号
//         userName : ,    //账号
//         password : ,    //密码
//     }
// }
export const register = data => {
  return requestData("post", "/applet/ALogin/register", data);
};

// 登录
// {
//     type :  ,           //登录类型：1-账号密码登录，2-手机号,验证码登录
//     wxUser : {          //账户密码登录的时候传递
//         userName : ,    //账号
//         password : ,    //密码
//     },
//     mobile : ,          //验证码登录的时候传递手机号
//     code : ,            //验证码登录的时候传递验证码

// {
//   "account":      ,       //账号（手机号）
//   "type":         ,       //登录类型：1 密码登录 , 2 手机号验证码登录
//   "password":     ,       //密码，登录类型为1时必传参数
//   "code":                 //验证码，登陆类型为2时必传参数
// }
// }
export const login = data => {
  return requestData("post", "/applet/ALogin/login", data);
};
// 获取验证码
// phone
export const getSMSVerificationCode = data => {
  return requestData("get", "/applet/ALogin/getSMSVerificationCode", data);
};

// 竞拍广场列表
// {
//     type : ,            //表头类型:1:进行中 2：已结束 3:流拍 4:即将开始 5:全部
//     dealType : ,        //货源或者订单 1是货源 2是订单
//     transactionType : , //竞拍类型 1是竞价 2是一口价 不传获取所有
//     category : "金枪鱼/大目/低温",   //品类品项规格名称以‘/’分隔
//     categoryType : ,    //原料或者半成品
//     pageNo : ,          //页码
//     pageSize :          //每页长度
// }
export const paimaiPageList = data => {
  return requestData("post", "/applet/AAuction/getAuctionList", data);
};
//获取竞价/挂牌数量
export const getAuctionCount = data => {
  return requestData("get", "/applet/AAuction/getAuctionCount", data);
};
// 拍品详情
// id  竞拍ID
export const paimaiDetails = data => {
  return requestData("get", "/applet/AAuction/auctionDetails", data);
};

// id  竞拍ID
export const screenDetails = data => {
  return requestData("post", "/httpClient/getDealDetailForChart", data);
};

//获取保证金余额 以及 相应冻结保证金
export const checkMarginAmount = data => {
  return requestData("post", "/applet/AAuction/checkMarginAmount", data);
};

// 报名
export const signUpAuction = data => {
  return requestData("post", "/applet/AAuction/applyAuction", data);
};

// 取消报名
// id  竞拍ID
export const cancelRegistration = data => {
  return requestData("get", "/applet/AAuction/cancelAuction", data);
};

// 设置提醒
// id  竞拍ID
export const setReminder = data => {
  return requestData("post", "/applet/AAuction/addOrCancelRemind", data);
};

// 历史出价
// id  竞拍ID
export const historyPrice = data => {
  return requestData("get", "/applet/AAuction/getAuctionOfferPriceList", data);
};

// 个人中心
// type 类型：竞拍成功-3，我参与的-2，我报名的5，我的需求-1
// pageNo 	页码
// pageSize 每页长度
export const myAllPage = data => {
  return requestData("get", "/auction/pc/myAllPage", data);
};

// 查询看货记录 根据竞拍id
// id  竞拍ID
export const getInspectionRecordDemandById = data => {
  return requestData("get", "/auction/pc/getInspectionRecordDemandById", data);
};

// 校验用户是否认证
export const getUserDetailsById = data => {
  return requestData("get", "/applet/user/getUserDetailsById", data);
};

// 获取客户信息
export const queryCustomerByUser = data => {
  return requestData("get", "/paimai/set/queryCustomerByUser", data);
};
// 出价
export const offerPrice = data => {
  return requestData("post", "/applet/AAuction/offerPrice", data);
};
// 轮播图
export const specialTitle = data => {
  return requestData("get", "/applet/ASpecial/queryAuctionSpecial", data);
};

// 识别身份证及营业执照
// imgPath 图片路径
// function 识别类型：1-身份证。2-营业执照 3组织机构+税务（营业执照15位要用）
// type 识别身份证时必须传type : face 正面 , back : 反面
export const OCRImageRecognition = data => {
  return requestData("get", "/applet/OCRImageRecognition", data);
};

// 用户认证
// {
//   "businessLicenseUrl": "",	//营业执照  type=2
//   "cardCopyUrl": "https://upload.huacaizhaoyu.com/upload_pic/91772a799db3410c8e562cc16814770c.jpg",  //身份证正面 type=1
//   "cardNationalUrl": "https://upload.huacaizhaoyu.com/upload_pic/9076493dc5e544808df3b5ad4806ee3d.jpg", //身份证返面 type=1
//   "city": "长治市",
//   "cityCode": "140400000000",
//   "contactName": "",  //联系人名称  type=2
//   "contactPhone": "15510435443", //联系人电话 type=2
//   "customerAppearance": "太平洋蓝鳍,黄鳍,条纹四鳍旗鱼",	//客户品项
//   "customerAttribute": "卖家",		//客户属性：买家    卖家     既是买家，也是卖家
//   "customerName": "奥巴马",		//客户名称
//   "customerType": "工厂",			//客户类型	工厂 批发商 餐饮店 个人
//   "district": "屯留区",
//   "districtCode": "140405000000",
//   "province": "山西省",
//   "provinceCode": "140000000000",
//   "street": "渔泽镇",
//   "streetCode": "140405102000",
//   "type": "1"   //认证类型：1-个人。2-企业
// }
export const userCertification = data => {
  return requestData("post", "/applet/user/certification", data);
};

// 上传图片接口
export const uploadPic = data => {
  return requestData("post", "/common/CUpload/uploadPic", data, {
    "Content-Type": "multipart/form-data"
  });
};

// 经营品项
export const certificationCategoryList = data => {
  return requestData("get", "/applet/user/certificationCategoryList", data);
};

// {
//   "id":   ,   //竞拍/挂牌的ID
//   "tradeType":    ,   //交易类型
//   "category":     ,   //品类
//   "appearance":   ,   //品项
//   "specifications":   ,   //规格
//   "freezingMode":     ,   //冷冻方式
//   "unit":     ,   //单位
//   "weight":   ,   //重量
//   "locationCodes":    ,   //货源地址编码集，省市区县编码使用逗号分隔的字符串
//   "locationNames":    ,   //货源地址名称集，省市区名称码使用逗号分隔的字符串
// "addressDetail":   ,	//详细地址
//   "imgs":     ,   //货源图片，只有tradeType=2/4时才有
//   "sourceText":   ,   //货源描述，只有tradeType=2/4时才有
//   "scheduledDate":    ,   //竞拍日期，只有tradeType=1/2时才有
//   "scheduledTime":    ,   //竞拍时间，只有tradeType=1/2时才有
//   "scheduledDuration":    ,   //竞拍时长，只有tradeType=1/2时才有
//   "iprice":   ,   //起拍价/一口价
//   "increments":   ,   //加价幅度，只有tradeType=1/2时才有
//   "freightBearer":    ,   //运费承担方
// }

export const publishAuction = data => {
  return requestData("post", "/applet/AAuction/publishAuction", data);
};

// 获取用户交易条件列表
export const getUserAuctionConditionList = data => {
  return requestData(
    "get",
    "/applet/ACommon/getUserAuctionConditionList",
    data
  );
};
// 获取用户交易条件列表
export const getRegionTree = data => {
  return requestData("get", "/common/CAuctionRegion/getRegionTree", data);
};
// 返回可选的竞价时间
export const queryAuctionSessions = data => {
  return requestData("get", "/applet/AAuction/queryAuctionSessions", data);
};
// 返回竞拍时长可选列表
export const queryAuctionDuration = data => {
  return requestData("get", "/applet/AAuction/queryAuctionDuration", data);
};

// 获取用户认证条件列表
export const getUserCertificationConditionList = data => {
  return requestData(
    "get",
    "/applet/ACommon/getUserCertificationConditionList",
    data
  );
};
// 开户信息查询
export const queryOpenAccount = data => {
  return requestData("get", "/applet/user/queryOpenAccount", data);
};
// 用户发布的交易列表
export const getUserPublishAuctionList = data => {
  return requestData("get", "/applet/AUser/getUserPublishAuctionList", data);
};

// 核对订单页
export const checkOrder = data => {
  return requestData("get", "/applet/AOrder/checkOrder", data);
};
//生成订单
export const createOrder = data => {
  return requestData("get", "/applet/AOrder/createOrder", data);
};

//生成订单
export const queryVirtualAccount = data => {
  return requestData("get", "/applet/user/queryVirtualAccount", data);
};

// 华采客服
export const customerService = data => {
  return requestData("get", "/applet/ACommon/customerService", data);
};
// 专属客服查询
export const getBusinessCard = data => {
  return requestData("get", "/applet/user/getBusinessCard", data);
};

// 我关注的
// type 1 代表 我报名的竞价，2 代表 我点赞的文章
// pageNo
// pageSize
export const getUserAttention = data => {
  return requestData("get", "/applet/AAUser/getUserAttention", data);
};
// 删除被驳回的交易
// id
export const deleteUserAuction = data => {
  return requestData("delete", "/applet/AUser/deleteUserAuction", data);
};
// 用户修改交易价格
// id
export const updateUserAuctionIprice = data => {
  return requestData("post", "/applet/AUser/updateUserAuctionIprice", data);
};
// 用户下架挂牌交易
// id
export const unshelveUserAuction = data => {
  return requestData("post", "/applet/AUser/unshelveUserAuction", data);
};
// 用户开户验证码银行卡验证持卡人手机号
export const getPersonalSmsCode = data => {
  return requestData("get", "/applet/user/getPersonalSmsCode", data);
};

export const openAccount = data => {
  return requestData("post", "/applet/user/openAccount", data);
};

// 全国银行列表查询
export const getBankList = data => {
  return requestData("get", "/applet/user/getBankList", data);
};

// 用户账户明细
export const accountTransactionDetails = data => {
  return requestData("get", "/applet/user/accountTransactionDetails", data);
};

// 用户钱包余额查询
export const getUserWalletAmount = data => {
  return requestData("get", "/applet/user/getUserWalletAmount", data);
};

//我的订单
export const getUserOrderList = data => {
  return requestData("get", "/applet/AAUser/getUserOrderList", data);
};
export const queryOrderDetails = data => {
  return requestData("get", "/applet/AOrder/queryOrderDetails", data);
};
//用户保证金有效余额查询
export const getMarginAccount = data => {
  return requestData("get", "/applet/user/getMarginAccount", data);
};

// 用户保证金转入转出
// type 1 转入 ,2 转出
// amount 金额
export const inOrOutMargin = data => {
  return requestData("post", "/applet/user/inOrOutMargin", data);
};
// 用户余额提现
// amount 金额
export const userWithdrawal = data => {
  return requestData("post", "/applet/user/userWithdrawal", data);
};
//获取报名列表
export const getUserAuctionNoticeList = data => {
  return requestData("get", "/applet/AUser/getUserAuctionNoticeList", data);
};
//获取报名详情
export const getUserAuctionNoticeDetails = data => {
  return requestData("get", "/applet/AUser/getUserAuctionNoticeDetails", data);
};
//针对报名货源 确认/驳回操作
export const playApplyFixedPrice = data => {
  return requestData("post", "/applet/AAuction/playApplyFixedPrice", data);
};
//竞价-我报名的列表
export const getMyAuctionAppleList = data => {
  return requestData("get", "/applet/AAuction/getMyAuctionAppleList", data);
};
//竞价-我报名的详情
export const getMyAuctionAppleDetails = data => {
  return requestData("get", "/applet/AAuction/getMyAuctionAppleDetails", data);
};

//竞价-我报名的详情
export const getAuctionAppleDetails = data => {
  return requestData("get", "/applet/AAuction/getAuctionAppleDetails", data);
};
//编辑订单竞价/挂牌报名信息
export const editAuctionApply = data => {
  return requestData("post", "/applet/AAuction/editAuctionApply", data);
};
//编辑订单竞价/挂牌报名信息
export const deleteAuctionApple = data => {
  return requestData("post", "/applet/AAuction/deleteAuctionApple", data);
};
// 用户认证邀请码
// inviteCode
export const inviteCodeConfirm = data => {
  return requestData("post", "/applet/user/inviteCodeConfirm", data);
};

//验证入驻保证金是否大于10万
export const checkAccountBySource = data => {
  return requestData("get", "/applet/AAuction/checkAccountBySource", data);
};

// 开户账户换绑银行卡
// "smsCode": "999999",
// "mobile": "15294967282",
// "bankAcctNo":"6228480019079904777",
// "accountName":"腾金鱼",
// "bankCode":"兴业银行股份有限公司北京上地支行"
export const changeAccountBank = data => {
  return requestData("post", "/applet/user/changeAccountBank", data);
};
export const updateHeadImg = data => {
  return requestData("put", "/applet/user/updateHeadImg", data);
};
// 更改账户(手机号)
// account
// code
export const changeAccount = data => {
  return requestData("post", "/applet/user/changeAccount", data);
};

// 修改密码;
// password
export const updatePassWord = data => {
  return requestData("post", "/applet/AUser/user/updatePassWord", data);
};

//更改账户(手机号)-校验手机号是否存在,存在发送短信验证码
export const checkChangeAccount = data => {
  return requestData("get", "/applet/user/checkChangeAccount", data);
};

//查询闭市时间，用于首页判断开市闭市
export const distinguishTimes = data => {
  return requestData("get", "/applet/ACommon/distinguishTimes", data);
};

//查询闭市时间，用于前端限制筛选
export const closingDateList = data => {
  return requestData("get", "/applet/AAuction/closingDateList", data);
};
//打款验证接口
export const paymentVerification = data => {
  return requestData("post", "/applet/user/paymentVerification", data);
};
//PC首页分类-竞价/挂牌列表
export const getCategoryAuctionList = data => {
  return requestData("get", "/applet/AAuction/getCategoryAuctionList", data);
};

//获取账号关联信息
export const getUserAccountAssociation = data => {
  return requestData("get", "/applet/user/getUserAccountAssociation", data);
};

//关联账号时获取验证码
export const getRelevanceAccountVerificationCode = data => {
  return requestData(
    "get",
    "/applet/user/getRelevanceAccountVerificationCode",
    data
  );
};

//关联子账号
export const relevanceAccount = data => {
  return requestData("post", "/applet/user/relevanceAccount", data);
};
//删除子账号关联
export const deleteRelevanceAccount = data => {
  return requestData("delete", "/applet/user/deleteRelevanceAccount", data);
};
//修改关联账号备注
export const updateRemarksName = data => {
  return requestData("post", "/applet/user/updateRemarksName", data);
};

export const querySystemNotice = data => {
  return requestData("get", "/applet/ACommon/querySystemNotice", data);
};



// WEBPACK FOOTER //
// ./src/request/api.js